(function() {
  "use strict";

    angular.module("eSign")
    .directive("documentListItem", ['$window', function($window) {
      return {
        restrict: 'E',
        replace: 'true',
        templateUrl: 'templates/DocumentItem.html',
        link: function(scope, element, attrs) {
          
          scope.openDocumentForAction = function(id) {
            scope.signTaskDocument.IsOpened = true;
            if (scope.documentSelected){
              scope.documentSelected(scope.signTaskDocument);
            }
          }

        },
        scope: {
          signTaskDocument: '=',
          documentSelected: '='
        }
      }
    }]);
}());
